import * as React from 'react';
import { List } from 'semantic-ui-react';

/** Meaning of each column of the fallback episodes table, in table order. */
const COLUMNS: { name: string; description: string; }[] = [
    { name: 'Route', description: 'Route short name of the trip.' },
    { name: 'Vehicle', description: 'Vehicle that stopped reporting positions.' },
    { name: 'Trip', description: 'Trip the vehicle was serving.' },
    { name: 'Last position', description: 'Time of the last real position before the gap.' },
    { name: 'Next position', description: 'Time of the next real position received after the gap.' },
    { name: 'Gap', description: 'Time without positions between the last and the next position.' },
    { name: 'Kept delay', description: 'Delay observed at the last position and kept by the feed during the fallback.' },
    { name: 'Delay at recovery', description: 'Delay reported when the vehicle came back (after the retention window for Expired episodes).' },
    { name: 'Delay error', description: 'Delay at recovery minus kept delay: positive when the vehicle fell further behind than the fallback assumed.' },
    { name: 'Outcome', description: 'Recovered: the vehicle reported again inside the retention window. Expired: the window ended first.' },
];

const FallbackEpisodesLegend: React.FC = () => (
    <List className="fallback-episodes-legend">
        {COLUMNS.map(({ name, description }) => (
            <List.Item key={name}>
                <strong>{name}:</strong> {description}
            </List.Item>
        ))}
    </List>
);

export default FallbackEpisodesLegend;
